module.exports = __webpack_public_path__ + "513aa607d398efaccc559916c3431403.ttf";